import { makeText, setHtml } from '../lib.js';
import { t } from '../localization.js';
import { fadeInTimeoutMS, fadeOut, handleFadeInOut, isClickOutside, isClicked, saveClick } from './utils.js';

export function show(text = t('home-ugc-tooltip-message')) {
  if (!isClicked('uploadPhotoBtnClicked')) {
    const element = makeText('.ugc-tooltip__text');
    setHtml(text, element);

    if (isClicked('faceRecoBtnClicked')) {
      setTimeout(() => handleFadeInOut('.ugc-tooltip'), fadeInTimeoutMS);
    }

    document.addEventListener('click', (event) => {
      const selectors = ['.top-panel', '.menu', '#qrr-overlay', '#qrr-container'];
      if (isClickOutside(event, selectors)) {
        fadeOut('.ugc-tooltip');
      }
    });
  }
}

export function Off() {
  saveClick('uploadPhotoBtnClicked');
  fadeOut('.ugc-tooltip');
}
